import React from 'react';
import { ImHappy } from 'react-icons/im';

export const UnderContraction = () => {
  return (
    <>
      <div className="text-center UnderContraction">
        <ImHappy />

        <h1>This page is under maintenance. </h1>
      </div>
    </>
  );
};
